import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';

// Functional Route guard to check if the user is logged in
export const isAdmin = () => {
  const _router = inject(Router);
  const _authService = inject(AuthService);

  if (_authService.loggedIn() && _authService.isAdmin()) {
    return true;
  } else {
    _router.navigate(['/login']);
    return false;
  }
};

